import React, { Component } from "react"
import { RouteComponentProps } from "react-router-dom"
import { connect } from "react-redux"
import { App } from "../../App"
import { AppState } from "../../store"
import { UserInfo } from "../../services/account/account-rest-interface"
import BellringersWeeklyTest from "./BellringersWeeklyTest"
import "./index.css"

const mapStateToProps = ({ account }: AppState) => ({
    userInfo: account.userInfo as UserInfo,
})

const mapDispatchToProps = { }

export interface StoreProps {
    userInfo: UserInfo
}

interface Props {

}

interface State {
    shouldRestoreNavbar: boolean
    testDetails: any
}

type AllProps = Props & StoreProps & RouteComponentProps<any>

/**
 * Bellringers are similar to the SAT practice test's look & feel.
 */
export class BellringersTestContainerView extends Component<AllProps, State> {
    constructor(props)  {
        super(props)

        this.state = {
            shouldRestoreNavbar: false,
            testDetails: undefined,
        }
    }

    async componentDidMount() {
        try {
            let newState: any = { }
            if (!App.isNavbarCollapsed()) {
                App.collapseNavbar()
                newState.shouldRestoreNavbar = true
            }
            this.setState(newState)
            App.hideNavbar()
        }
        catch (err) {
            console.error("Failed to load the test details!")
        }
    }

    componentWillUnmount() {
        if (this.state.shouldRestoreNavbar) {
            if (App.isNavbarCollapsed()) {
                App.collapseNavbar(false)
            }
        }
        App.hideNavbar(false)
    }

    handleTestExit = (testName: string) => {
        let {props} = this as any
        props.history.goBack()
    }

    render() {
        let props: any = this.props
        let bellringersTestId = props.match.params.bellringersTestId
        let testTitle = bellringersTestId
        let {userInfo} = props

        return (
            <div className="bellringers-test-container">
                <BellringersWeeklyTest userInfo={userInfo} bellringersTestId={bellringersTestId}/>
            </div>
        )
    }
}

const BellringersTestConnectedContainer = connect<StoreProps, {}, {}, AppState>(mapStateToProps, mapDispatchToProps)(BellringersTestContainerView)

export default (props) => {
    return (
        <BellringersTestConnectedContainer {...props} />
    )
}
